'use client'

import { useCallback, useState } from 'react'

import type { TimeValue } from '@graftcode/design-system'

import type { ServiceMapCustomRange } from '../time-range.types'

const EMPTY_RANGE: ServiceMapCustomRange = {
  startDate: null,
  startTime: null,
  endDate: null,
  endTime: null,
}

type UseCustomRangeStateResult = {
  range: ServiceMapCustomRange
  setRange: (range: ServiceMapCustomRange) => void
  setStartDate: (value: Date | null) => void
  setStartTime: (value: TimeValue | null) => void
  setEndDate: (value: Date | null) => void
  setEndTime: (value: TimeValue | null) => void
}

export function useCustomRangeState(initial?: ServiceMapCustomRange): UseCustomRangeStateResult {
  const [range, setRangeState] = useState<ServiceMapCustomRange>(initial ?? EMPTY_RANGE)

  const setRange = useCallback((next: ServiceMapCustomRange) => setRangeState(next), [])
  const setStartDate = useCallback((value: Date | null) => setRangeState((curr) => ({ ...curr, startDate: value })), [])
  const setStartTime = useCallback(
    (value: TimeValue | null) => setRangeState((curr) => ({ ...curr, startTime: value })),
    []
  )
  const setEndDate = useCallback((value: Date | null) => setRangeState((curr) => ({ ...curr, endDate: value })), [])
  const setEndTime = useCallback(
    (value: TimeValue | null) => setRangeState((curr) => ({ ...curr, endTime: value })),
    []
  )

  return { range, setRange, setStartDate, setStartTime, setEndDate, setEndTime }
}
